import {Component, ElementRef, HostListener, Input, ViewChild} from '@angular/core';

@Component({
  selector: 'app-section',
  imports: [],
  templateUrl: './section.component.html',
  standalone: true,
  styleUrl: './section.component.scss'
})
export class SectionComponent {
  @ViewChild('section', { static: false }) private section!: ElementRef;
  @Input() sticky: boolean = false;
  height = 0;
  isVisible: boolean = true;
  @HostListener('window:scroll', ['$event'])
  textAppear(event: WheelEvent) {
    event.preventDefault();
    const rect = this.section?.nativeElement.getBoundingClientRect();
    const distanceToTop = rect.top; // Расстояние до верхней части экрана
    this.isVisible = distanceToTop <= window.innerHeight - 100;
  }
}
